/**************************************************
 * Nombre:       Seccion_Equipos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import {usuarioContext} from "../../App";
import Tarjeta_Bonos from "../Tarjetas_Especiales/Tarjeta_Bonos";
import Tarjeta_Plan_Carrera from "../Tarjetas_Especiales/Tarjeta_Plan_Carrera";
import FilaEquipo from "./Componentes/FilaEquipo";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import Tarjeta_Premios from "../Tarjetas_Especiales/Tarjeta_Premios";
import {irArriba} from "../../Utilidades/irArriba";


const Seccion_Equipos = () => {
    const cData = useContext(usuarioContext)
    const [equipo, setEquipo] = useState({})


    useEffect(() => {

        irArriba()

        obtenerDoc('equipos', cData.usuario.id).then((dox) => {

            if (dox.res) {
                setEquipo(dox.data)
            }
        })

    }, [cData]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', color: 'white', pb: 10, pt: 8}}
                spacing={4}
            >

                <Grid container size={{xs: 12, sm: 6, md: 5}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Premios/>
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 5}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Bonos/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Plan_Carrera/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{color: '#fff'}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontWeight: 600, fontSize: 24}}>Equipo</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <FilaEquipo items={equipo['0']} titulo={'Primero'} porcentaje={10}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <FilaEquipo items={equipo['1']} titulo={'Segundo'} porcentaje={8}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <FilaEquipo items={equipo['2']} titulo={'Tercero'} porcentaje={6}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <FilaEquipo items={equipo['3']} titulo={'Cuarto'} porcentaje={4}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <FilaEquipo items={equipo['4']} titulo={'Quinto'} porcentaje={2}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <FilaEquipo items={equipo['5']} titulo={'Sexto'} porcentaje={1}/>
                                </Grid>


                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Equipos

const item = {

    primero: [1],
    segundo: [1, 2],
    tercero: [1, 2, 3],
    cuarto: [1, 2, 3, 4],
    quito: [1, 2, 3, 4, 5],
    sexto: [1, 2, 3, 4, 5, 6],
}

//

